import React from 'react'

const MenuTextItem: React.FC<{
    text: string
    isActive: boolean
    theme: string
    onClick: () => void
}> = ({ text, isActive, onClick, theme }) => {
    return (
        <li>
            <span
                className={
                    'flex w-12 h-12 rounded-lg items-center p-1 cursor-pointer hover:bg-[#cccccc] dark:hover:bg-[#464447]' +
                    (isActive ? ' bg-[#cccccc] dark:bg-[#464447]' : '')
                }
                onClick={onClick}
            >
                <div
                    className={`flex w-full aspect-square rounded-full bg-[#f6f6f6] dark:bg-[#262427] items-center justify-center text-[14px] font-semibold ${isActive ? ' text-[#181818] dark:text-[#FFFFFF]' : 'text-[#8A8A8A] hover:text-[#8A8A8A] dark:text-[#8A8A8A]'}`}
                >
                    {text}
                </div>
            </span>
        </li>
    )
}

export default MenuTextItem
